import { atomWithStorage } from 'jotai/utils';

export type ActiveSyncRequest = {
  encryptId: string;
  jobSourceTitle: string | null;
};

export const activeSyncRequestAtom = atomWithStorage<ActiveSyncRequest | null>(
  'sharedJobPostSyncRequest',
  null
);
